export default {
    paylist() {
        let paylist = []
        for (let i = 1; i <= 60; i++) {
            let arr = {
                label: `${i}K`,
                value: i
            }
            paylist.push(arr)
        }
        return paylist
    },
    getmonth() {
        let month = []
        for (let i = 12; i <= 24; i++) {
            let arr = {
                value: `${i}个月`,
                key: i
            }
            month.push(arr)
        }
        return month
    },
    downLoadFile(data, fileName) {
        let url = window.URL.createObjectURL(data)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link) //下载完成移除元素
        window.URL.revokeObjectURL(url) //释放掉blob对象
    },
    //时间格式化
    settimestring(time) {
        let date = new Date(time);
        let YYYY = date.getFullYear(); //年
        let MM =
            date.getMonth() + 1 ? `0${date.getMonth() + 1}` : date.getMonth() + 1; //月
        let dd = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate(); //日
        let hh = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours(); //时
        let mm =
            date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes(); //分
        let ss =
            date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds(); //秒
        let text = `${YYYY}年${MM}月${dd}日 ${hh}:${mm}:${ss}`;
        return text;
    },
}